import { render } from "./questionPopup.vue?vue&type=template&id=01e395d2&scoped=true"
import script from "./questionPopup.vue?vue&type=script&lang=js"
export * from "./questionPopup.vue?vue&type=script&lang=js"

import "./questionPopup.vue?vue&type=style&index=0&id=01e395d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01e395d2"]])

export default __exports__